import EmptyState from '@atlaskit/empty-state';
import { SpinnerMask } from '@atlassian/amkt-common';
import React from 'react';
import TabHeader from "../../../common/components/Tabs/TabHeader";
import { usePartnerDetails } from "../../../common/hooks.js";
import PartnerSecurityDetails from "./PartnerSecurityDetails";
import GenericErrorImage from "../../../common/components/generic-error.svg";

const PartnerSecurity = ({
  mpacBaseUrl,
  partnerId
}) => {
  const {
    partnerDetails,
    partnerDetailsPending,
    partnerDetailsError
  } = usePartnerDetails(mpacBaseUrl, partnerId);

  if (partnerDetailsError) {
    return /*#__PURE__*/React.createElement(EmptyState, {
      header: "We ran into a little trouble",
      description: "It might just be a hiccup. Try again in a bit.",
      imageUrl: GenericErrorImage
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Security"
  }), /*#__PURE__*/React.createElement(SpinnerMask, {
    active: partnerDetailsPending,
    size: 50,
    completeImmediately: true
  }, /*#__PURE__*/React.createElement(PartnerSecurityDetails, {
    cloudSecurity: partnerDetails === null || partnerDetails === void 0 ? void 0 : partnerDetails.cloudSecurity
  })));
};

export default PartnerSecurity;